import { ConsentManager } from "../../../../../../../../../libs/shared/src/lib/enums/consent/consent-manager.enum";
export class DiscoveryComponentIntegrationViewModel {
    trafficPercentage: number;
    defaultWebsiteUrl: string;
    bookingEngineTemplateUrl: string; // this one is for global planner flow
    prefix: string;
    code: string;
    signatureUserUuid: string;
    signatureText: string;
    facadeDelayInMs: number;
    consentManager: ConsentManager; 
    functionalConsentGroup: string; 
    analyticsConsentGroup: string;
    isBrowserBackButtonNavActive: boolean;
    siteIntegrationUuid?: string;
    languageData: {
        bookingEngineTemplateUrl: string;
        languageCode: string;
    }[];
}
